/**
 * Parsed quote Last price. Connect Trade hydrates Last from the latest 1m PreAndPost bar
 * (with daily bars for day-change fields) on the backend;
 * callers must not fall back to Trade, bid/ask, or chart bars.
 *
 * @returns {number|null}
 */
export function parseQuoteLast(quote) {
  if (!quote?.Last) return null;
  const last = parseFloat(quote.Last);
  return Number.isFinite(last) && last > 0 ? last : null;
}

/**
 * Display percent for a quote's daily net change.
 *
 * TradeStation **streaming** quotes expose `NetChangePct` as a decimal rate (e.g. "0.035" → 3.5%).
 * The backend normalizes **snapshot** GET responses to the same decimal form, so the UI can
 * always interpret `NetChangePct` as a fraction and multiply by 100 for the "%" label.
 *
 * @returns {number} Scale used for labels (e.g. -2.25 means "-2.25%")
 */
export function netChangePctToDisplayPercent(quote) {
  if (!quote || quote.NetChangePct == null) return NaN;
  const raw = parseFloat(quote.NetChangePct);
  if (Number.isNaN(raw)) return NaN;
  return raw * 100;
}

/**
 * Previous regular-session close. Prefer the quote field; otherwise back out of Last + NetChangePct.
 */
export function parsePreviousClose(quote) {
  const direct = parseFloat(quote?.PreviousClose);
  if (Number.isFinite(direct) && direct > 0) return direct;
  const last = parseQuoteLast(quote);
  const rawPct = quote?.NetChangePct == null ? NaN : parseFloat(quote.NetChangePct);
  if (last && Number.isFinite(rawPct) && rawPct > -1) {
    const inferred = last / (1 + rawPct);
    return Number.isFinite(inferred) && inferred > 0 ? inferred : null;
  }
  return null;
}
